export enum ATDLNParameterType {
  AMT, // Amt_t	Use for fixed currency amounts //	Takes on precision of selected fixed currency
  ANY_URI,
  BOOLEAN_FIX, // Boolean_t	Single character Boolean //	True is represented ‘Y’ and false by ‘N’
  BOOLEAN_XML,
  BORDER,
  CHAR, // Single character
  COUNTRY,
  CURRENCY,
  DECIMAL,
  //DOUBLE,
  FLOAT, // Float_t	A positive or negative float //	When rendered with SingleStepper control, it takes on rate and step precisions of selected currency pair
  EXCHANGE,
  INT, // Int_t	A positive or negative integer // When rendered with SingleStepper control, uses amount shortcuts on entry
  LANGUAGE,
  LENGTH,
  LOCALMKTTZ,
  MONTHYEAR,
  MULTICHAR,
  MULTISTRING,
  ORIENTATION,
  PERCENT, // Percentage_t	A float from 0-1 // When rendered with SingleStepper control, it has restricted range of 0-100, value is divided by 100 before storing
  TAGNUM,
  NUMGROUP,
  POSINT,
  PRICE, // Price_t	A positive float //	When rendered with SingleStepper control, it takes on rate and step precisions of selected currency pair
  PRICE_OFFSET, // PriceOffset_t	A positive or negative float // When rendered with SingleStepper control, it takes on rate and step precisions of selected currency pair
  QTY, // Qty_t	Use for counter currency amounts // Takes on precision of selected counter currency
  SEQNUM,
  STRING, // Arbitrary text value
  STRINGID,
  TIME,
  DATE,
  TZTIMESTAMP,
  TZTIMEONLY,
  TENOR, // Tenor value in form[DMWY][count] e.g. D5, M10
  UTCDATEONLY,
  UTCTIMEONLY, // UTCTimeOnly_t	Format or ‘HH:MM[:SS]’ //	When used with a Clock control, the hours are not constrained to 24 to enable this to represent a duration
  UTCTIMESTAMP,
}
